<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="monthReport">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i>月度维保报告
        </span>
        <div class="w_normalNav" :parent="self">
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="BlueSmBtn" @click="subSeefrom">检查</button>
        </div>
        <div class="searchForm1">
          <el-form :model="seefrom" ref="seefrom" :rules="rules">
            <el-form-item label="维保公司:" prop="deptName">
              <el-input placeholder="请选择维保公司" v-model="seefrom.deptName" readonly @focus="selectDept"></el-input>
            </el-form-item>
            <el-form-item label="维保区域:" prop="areaName">
              <el-input placeholder="请选择维保区域" @focus="checkAreas" class="detail_input" v-model="seefrom.areaName"></el-input>
              <selectRegion :hasChildNodes="areaTreeMode" :dialogVisible="areaTreeVisible" @regionTreeClose="areaTreeVisible = false" @regionTreeData="selRegionData" :deptId="null">
              </selectRegion>
            </el-form-item>
            <el-form-item label="年份:" prop="year">
              <el-select :popper-append-to-body="false" v-model="seefrom.year" placeholder="请选择年份" style="width:100%" clearable>
                <el-option v-for="(item,index) in yearList" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="月份:" prop="month">
              <el-select :popper-append-to-body="false" v-model="seefrom.month" placeholder="请选择年份" style="width:100%" clearable>
                <el-option v-for="(item,index) in monthList" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="tableWrapper">
          <div class="container" style="border: none;padding: 0;">
            <div class="content">
              <div class="tips"><span style="color: red;margin-right: 5px;">*</span>Tips:请选择上方的筛选条件后生成月度报告再点击下载!</div>
            </div>
          </div>
          <div class="container" v-if="isSelect">
            <div class="content">
              <div class="item">巡检任务：{{ reportDetail.sum }}个，已完成：{{ reportDetail.completedCount }}个</div>
              <div class="item">维修任务：{{ reportDetail.repairSum }}个，已完成：{{ reportDetail.repairCompletedCount }}个</div>
              <div class="tips"><span style="color: red;margin-right: 5px;">*</span>Tips:生成报告前,请先点击检查,获取条件下任务完成情况,未全部完成的暂不支持生成及下载月度报告!</div>
            </div>
            <div class="btn" v-if="reportDetail.sum === reportDetail.completedCount && reportDetail.sum != 0">
              <el-button class="w_next_button cancelButton" @click="generateReport">生成报告</el-button>
              <el-button class="w_next_button confirmButton" type="primary" @click="downloadReport">下载报告</el-button>
            </div>
          </div>
          <div id="resume" style="width: 796px;margin: 0 auto" ref="mainContainer" v-if="isShowReport">
            <div class="pageOne">
              <div class="title">建筑消防设施维保报告</div>
              <div class="pageItem">
                <div class="name" style="width: 147px">维保建筑（单位）</div>：
                <div class="value" style="width: 406px">{{ reportDetail.maintenanceBuilding }}</div>
              </div>
              <div class="pageItem">
                <div class="name">地址</div>：
                <div class="value">{{ reportDetail.address }}</div>
              </div>
              <div class="pageItem">
                <div class="name">委托单位</div>：
                <div class="value">{{ reportDetail.topDeptName }}</div>
              </div>
              <div class="pageItem">
                <div class="name">维保单位</div>：
                <div class="value">{{ reportDetail.deptName }}</div>
              </div>
              <div class="pageItem">
                <div class="name">维保时间</div>：
                <div class="value">{{ reportDetail.maintenanceDate }}</div>
              </div>
              <div class="pageTip">（此记录表一式三份，一份交委托单位，一份交消防机构，一份维保机构留存）</div>
            </div>
            <div class="pageTwo">
              <div class="title">成员信息表</div>
              <el-table :data="tableData" border>
                <el-table-column label="序号" prop="index" align="center"></el-table-column>
                <el-table-column label="角色" prop="role" align="center"></el-table-column>
                <el-table-column label="姓名" prop="name" align="center"></el-table-column>
                <el-table-column label="联系方式" prop="userPhone" align="center"></el-table-column>
                <el-table-column label="签名" prop="sign" align="center"></el-table-column>
              </el-table>
            </div>
            <div class="pageThree">
              <p class="paragraph">根据双方签订的消防设施维护保养合同的相关约定，在贵单位人员的配合下，我公司维护保养人员于{{ reportDetail.maintenanceDate }}对贵单位的相关消防设施进行了系统的维护保养与检查工作，现将有关检查情况总结如下（本报告只对当时检查内容有效）。</p>
              <p class="paragraph">一、项目概况</p>
              <p class="paragraph">{{ reportDetail.address }}共设有{{ reportDetail.fireControlSystemNames }}等。</p>
              <p class="paragraph">维保内容包含消防系统巡检、消防设施的维护保养及消防零星维修、安全标识牌及消防管道外漆维护。</p>
              <p class="paragraph">二、维保情况</p>
              <div class="customTable">
                <div class="customTitle">维保项目及情况</div>
                <template v-if="situationList.length > 0">
                  <div class="projectList" v-for="(item, index) in situationList" :key="index">
                    <div class="projectList-left">{{ item.name }}</div>
                    <div class="projectList-right">
                      <div class="right-info" v-for="(bitem, i) in item.contentArr" :key="i">
                        <div class="position">{{ bitem.name }}</div>
                        <div class="place">检查部位：{{ bitem.position }}</div>
                      </div>
                      <div class="situation">
                        <div class="title">维保情况：</div>
                        <div class="situationInfo" v-if="item.remarkList.length > 0">
                          <div v-for="(sItem, idx) in item.remarkList" :key="idx">{{ idx + 1}}、 {{ sItem }}</div>
                        </div>
                        <div class="situationInfo" v-else>
                          <div>正常</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="pageFour">
              <p class="paragraph">三、问题分析</p>
              <p class="paragraph">问题趋势</p>
              <div class="trendChart">
                <simple-chart :option="trendChart"></simple-chart>
              </div>
              <p class="paragraph">问题对比</p>
              <div class="trendChart">
                <simple-chart :option="contrastChart"></simple-chart>
              </div>
              <p class="paragraph">四、问题反馈</p>
              <div v-for="(item, index) in problemList" :key="index">
                <p class="paragraph">问题{{ index + 1 }}：{{ item.problem }}</p>
                <p class="paragraph">维修情况：{{ item.situation }}</p>
                <p class="paragraph">结果：{{ item.result }}</p>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <company-dialog ref="companyDialg" @confirm="confirmSelect" status="search"></company-dialog>
  </div>
</template>

<script>
import { getLatestYear } from 'utils'
export default {
  name: 'monthReport',
  data() {
    return {
      form_jsgl: {},
      items: [],
      yearList: [],
      monthList: [
        {
          label: '01',
          value: 1
        },
        {
          label: '02',
          value: 2
        },
        {
          label: '03',
          value: 3
        },
        {
          label: '04',
          value: 4
        },
        {
          label: '05',
          value: 5
        },
        {
          label: '06',
          value: 6
        },
        {
          label: '07',
          value: 7
        },
        {
          label: '08',
          value: 8
        },
        {
          label: '09',
          value: 9
        },
        {
          label: '10',
          value: 10
        },
        {
          label: '11',
          value: 11
        },
        {
          label: '12',
          value: 12
        }
      ],
      tabName: 'monthReport',
      seefrom: {
        deptId: undefined,
        deptName: undefined,
        areaId: undefined,
        areaName: undefined,
        year: undefined,
        month: undefined
      },
      areaTreeVisible: false,
      areaTreeMode: false,
      tableData: [],
      trendChart: {
        color: ['rgb(0,191,255)'],
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            color: 'rgb(187,190,199)',
            rotate: 90
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgb(218,220,225)'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgb(218,220,225)'
            }
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: 'rgb(202,203,205)'
            }
          },
          axisLabel: {
            color: '#000',
            fontSize: 12
          }
        },
        series: [
          {
            data: [],
            type: 'bar'
          }
        ]
      },
      contrastData: [],
      contrastChart: {},
      situationList: [],
      reportDetail: {},
      problemList: [],
      isShowReport: false,
      rules: {
        year: [{ required: true, message: '请选择年份', trigger: 'change' }],
        month: [{ required: true, message: '请选择年份', trigger: 'change' }],
        deptName: [{ required: true, message: '请选择维保单位' }],
        areaName: [{ required: true, message: '请选择维保区域' }]
      },
      isSelect: false
    }
  },
  computed: {
    self() {
      return this
    }
  },
  components: {
    normalNav: () => import('public/normalNav'),
    searchForm: () => import('public/searchForm'),
    companyDialog: () => import('./companyDialog'),
    selectRegion: () => import('./selectRegion/index'),
    simpleChart: () => import('./simpleChart'),
    downloadBtn: () => import('public/download')
  },
  methods: {
    selectDept() {
      let obj = {}
      if (this.seefrom.deptId) {
        obj.id = this.seefrom.deptId
        obj.label = this.seefrom.deptName
        this.$refs.companyDialg.look(obj)
      } else {
        this.$refs.companyDialg.look(obj)
      }
    },
    confirmSelect(id, name) {
      this.$set(this.seefrom, 'deptId', id)
      this.$set(this.seefrom, 'deptName', name)
    },
    checkAreas() {
      this.areaTreeVisible = true
    },
    selRegionData(a) {
      this.$set(this.seefrom, 'areaName', a.name)
      this.$set(this.seefrom, 'areaId', a.id)
    },
    //搜索
    subSeefrom() {
      this.$refs.seefrom.validate((valid) => {
        if (valid) {
          this.isSelect = true
          this.getTableData()
        }
      })
    },
    //重置
    reset() {
      this.$refs.seefrom.resetFields()
      this.seefrom.deptId = undefined
      this.seefrom.areaId = undefined
      this.isSelect = false
      this.isShowReport = false
    },
    //查询表格数据
    getTableData() {
      this.$axiospost(
        `extra/maintenanceTask/monthReport?areaId=${this.seefrom.areaId}&deptId=${this.seefrom.deptId}&month=${this.seefrom.month}&year=${this.seefrom.year}`
      ).then((res) => {
        this.reportDetail = res.data.data
        this.isShowReport = false
      })
    },
    generateReport() {
      if (
        this.reportDetail.sum === this.reportDetail.completedCount &&
        this.reportDetail.sum != 0
      ) {
        this.isShowReport = true
        this.tableData = this.reportDetail.empList.map((item, index) => {
          return {
            ...item,
            role: '维保人员',
            index: index + 1
          }
        })
        let maintenanceSituation = this.reportDetail.maintenanceSituation
        const arr = Object.entries(maintenanceSituation).map(
          ([key, content]) => {
            const contentArr = Object.entries(content)
              .filter(([bKey]) => bKey !== 'remarkList')
              .map(([bKey, position]) => ({ name: bKey, position }))
            return { name: key, contentArr, remarkList: content.remarkList }
          }
        )
        this.situationList = arr
        this.problemList = this.reportDetail.problems

        let contrastData = Object.entries(this.reportDetail.pic).map(
          ([key, value]) => ({ name: key, value })
        )

        this.contrastData = contrastData
        this.setContrastChart()
        this.trendChart.xAxis.data = this.reportDetail.days.map(
          (item) => item + '日'
        )
        this.trendChart.series[0].data = this.reportDetail.counts
      } else {
        this.isShowReport = false
      }
    },
    downloadReport() {
      this.$axios({
        url: process.env.API_HOST + 'extra/maintenanceTask/export/monthReport',
        method: 'post',
        responseType: 'blob',
        params: {
          ...this.seefrom
        }
      }).then((res) => {
        let fileName = decodeURIComponent(
          res.headers['content-disposition'].split('=')[1]
        )
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        fileName = fileName.replaceAll('"', '')
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    setContrastChart() {
      let total = 0
      this.contrastData.forEach((item) => {
        total += item.value
      })
      this.contrastData = this.contrastData.map((item) => {
        return {
          ...item,
          percent:
            total != 0 ? Math.round((item.value / total) * 10000) / 100.0 : 0
        }
      })
      let name1 = this.contrastData.filter((item, index) => {
        if (index < this.contrastData.length / 2) {
          return item.name
        }
      })
      let name2 = this.contrastData.filter((item, index) => {
        if (index >= this.contrastData.length / 2) {
          return item.name
        }
      })
      this.contrastChart = {
        tooltip: {
          show: false
        },
        legend: [
          {
            width: '100%',
            itemWidth: 10,
            itemHeight: 10,
            icon: 'circle',
            textStyle: {
              rich: {
                label: {
                  fontSize: 12,
                  lineHeight: 16,
                  color: '#3e3e3e',
                  padding: [0, 5, 0, 0]
                },
                value: {
                  fontSize: 12,
                  lineHeight: 17,
                  color: '#3e3e3e'
                }
              }
            },
            itemGap: 15,
            orient: 'vertical',
            right: 190,
            top: '30%',
            bottom: 30,
            data: name1.map((item) => {
              return item.name
            }),
            formatter: (name) => {
              let v = 0,
                target = 0
              for (var i = 0; i < name1.length; i++) {
                if (name1[i].name === name) {
                  target = name1[i].value
                  v = name1[i].percent
                }
              }
              return `{label|${name}}{value|${target}(${v}%})`
            }
          },
          {
            width: '100%',
            itemWidth: 10,
            itemHeight: 10,
            icon: 'circle',
            textStyle: {
              rich: {
                label: {
                  fontSize: 12,
                  lineHeight: 16,
                  color: '#3e3e3e',
                  padding: [0, 5, 0, 0]
                },
                value: {
                  fontSize: 12,
                  lineHeight: 17,
                  color: '#3e3e3e'
                }
              }
            },
            itemGap: 15,
            orient: 'vertical',
            right: 0,
            top: '30%',
            bottom: 30,
            data: name2.map((item) => {
              return item.name
            }),
            formatter: (name) => {
              let v = 0,
                target = 0
              for (var i = 0; i < name2.length; i++) {
                if (name2[i].name === name) {
                  target = name2[i].value
                  v = name2[i].percent
                }
              }
              return `{label|${name}}{value|${target}(${v}%})`
            }
          }
        ],
        series: [
          {
            name: 'Access From',
            type: 'pie',
            center: ['20%', '50%'],
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: false
              }
            },
            labelLine: {
              show: false
            },
            data: this.contrastData
          }
        ]
      }
    }
  },
  created() {
    this.yearList = getLatestYear(2, 0)
  }
}
</script>

<style lang="less">
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.el-input__inner:focus {
  border: 1px solid #3587c7;
}
</style>

<style lang="less" scoped>
.cust_dialog /deep/ .el-dialog__body {
  padding-top: 35px;
}
.cust_dialog {
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
}

.container {
  margin: 20px 0;
  border: 1px solid #214c71;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #212740;
    padding: 20px;
    font-size: 15px;
    color: #f5f5f5;
  }

  .btn {
    margin-top: 20px;

    .w_next_button {
      width: 150px;
    }

    .confirmButton {
      margin-left: 30px;
    }
  }
}

.pageOne {
  background: #fff;
  margin: 20px auto;
  display: flex;
  flex-direction: column;

  .title {
    text-align: center;
    margin: 300px 0 240px;
    font-size: 29px;
    color: #000;
    font-family: '黑体';
  }

  .pageItem {
    display: flex;
    align-items: center;
    margin-left: 120px;
    font-size: 18px;
    margin-bottom: 20px;
    color: #000;

    .name {
      width: 100px;
      font-family: '宋体';
      font-weight: bold;
      text-align: justify;
      text-align-last: justify;
    }

    .value {
      width: 453px;
      color: #000;
      text-align: center;
      border-bottom: 1px solid #000;
    }
  }

  .pageTip {
    margin: 110px 0;
    text-align: center;
    font-size: 16px;
    color: #000;
  }
}

.pageTwo {
  background: #fff;
  padding: 120px 110px 80px;
  margin: 20px auto;
  min-height: 1000px;

  .title {
    text-align: center;
    font-size: 18px;
    margin-bottom: 10px;
    color: #000;
    font-weight: bold;
  }

  /deep/ .el-table {
    height: auto;
  }

  /deep/ .el-table thead th {
    background: #fff;
    color: #000;
    font-size: 18px;
  }

  /deep/ .el-table tbody tr:nth-child(2n) {
    background: #fff;
  }
  /deep/ .el-table {
    .el-table--border td,
    .el-table--border th,
    .el-table__body-wrapper
      .el-table--border.is-scrolling-left
      ~ .el-table__fixed {
      border-color: #000;
    }

    td,
    th.is-leaf {
      border-color: #000;
    }
  }

  /deep/ .el-table--border,
  .el-table--group {
    border-color: #000;
  }

  /deep/ .el-table--border th {
    border-right: 1px solid #000;
    border-bottom: 1px solid #000;
  }
  /deep/ .el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    background: #000;
  }
}

.pageThree {
  background: #fff;
  padding: 80px 70px;
  margin: 20px auto;
}

.paragraph {
  text-indent: 2em;
  font-size: 18px;
  color: #000;
  font-family: '宋体';
  line-height: 1.8;
}

.trendChart {
  height: 280px;
}

.customTable {
  border: 1px solid #000;
  border-bottom: 0;
  font-size: 18px;
  font-family: '宋体';
  color: #000;
  margin-bottom: 60px;

  .customTitle {
    height: 30px;
    line-height: 30px;
    border-bottom: 1px solid #000;
    text-align: center;
  }

  .projectList {
    display: flex;

    &-left {
      width: 220px;
      padding: 0 10px;
      display: flex;
      align-items: center;
      text-align: center;
      border-right: 1px solid #000;
      border-bottom: 1px solid #000;
    }

    &-right {
      flex: 1;
      .right-info {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #000;

        .position {
          width: 140px;
          height: 100%;
          padding: 0 10px;
          display: flex;
          align-items: center;
          text-align: center;
        }

        .place {
          flex: 1;
          padding: 10px;
          border-left: 1px solid #000;
        }
      }

      .situation {
        border-bottom: 1px solid #000;
        padding: 10px;

        .situationInfo {
          display: flex;
          flex-direction: column;
        }
      }
    }
  }
}

.pageFour {
  background: #fff;
  padding: 80px 70px;
  margin: 20px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/wbManage/monthReport/index.vue